import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=230f8300"
import script from "./classify.vue?vue&type=script&lang=ts"
export * from "./classify.vue?vue&type=script&lang=ts"
import style0 from "./classify.vue?vue&type=style&index=0&id=230f8300&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports